import { render, staticRenderFns } from "./ExternalTicketCreated.vue?vue&type=template&id=6866df24&"
import script from "./ExternalTicketCreated.vue?vue&type=script&lang=js&"
export * from "./ExternalTicketCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports